import { render, staticRenderFns } from "./ClientSetup.vue?vue&type=template&id=8d057918&scoped=true&"
import script from "./ClientSetup.vue?vue&type=script&lang=ts&"
export * from "./ClientSetup.vue?vue&type=script&lang=ts&"
import style0 from "./ClientSetup.vue?vue&type=style&index=0&id=8d057918&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d057918",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VBtn,VIcon,VSpacer,VStepper,VStepperContent,VStepperStep})
